import React, { useState } from "react";
import styled from "styled-components";
import PostItem from "./PostItem";
import { useLanguage } from "../LangTranslation/LanguageContext";
import { sortList } from "../../utilities/sorting";

const PostsListContainer = styled.div`
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  max-height: 800px;
  .posts_text {
    color: #323b4b;
    font-size: 18px;
    family-font: "Inter";
    font-weight: 700;
  }
  @media (max-width: 425px) {
    max-height: 280px;
  }
`;
const SelectOption = styled.select`
  width: 100%;
  height: 35px;
  color: #b0b7c3;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  border-radius: 14px;
  border: none;
  background-color: #f8f9fa;
  padding: 8px;
  border: none;
  margin: 0px 0px 10px 0px;
  .defalut_txt {
    color: #000000;
  }
`;

const PostsList = ({
  posts,
  setPostList,
  setSelectedPost,
  selectedPost,
  selectedPlatform,
  isLoadingPosts,
}) => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const [sortOrder, setSortOrder] = useState("asc");

  const handleSortOrderChange = (event) => {
    const selectedOrder = event.target.value;
    setSortOrder(selectedOrder);
    if (selectedOrder) {
      sortList({ order: selectedOrder, list: posts, setList: setPostList });
    }
  };

  return (
    <PostsListContainer
      className="post_list_container"
      style={{ maxHeight: "100%", height: "100%" }}
    >
      <div className="d-flex justify-content-between">
        <div className="posts_text">{t["Posts"]}</div>
        <div>
          <SelectOption
            value={sortOrder}
            onChange={(event) => handleSortOrderChange(event)}
          >
            <option value={"asc"}>Ascending</option>
            <option value={"dsc"}>Descending</option>
          </SelectOption>
        </div>
      </div>
      <div
        className=""
        style={{
          overflowY: "auto",
          maxHeight: "100vh",
          height: "100vh",
        }}
      >
        {posts.length > 0 ? (
          posts.map((post) => (
            <PostItem
              key={post.post_id}
              {...post}
              setSelectedPost={setSelectedPost}
              selectedPost={selectedPost}
              selectedPlatform={selectedPlatform}
            />
          ))
        ) : (
          <div
            className={`d-flex justify-content-center align-items-center w-100 h-100 fs-6 text-secondary ${
              isLoadingPosts ? "flex-column" : ""
            }`}
          >
            {!isLoadingPosts ? (
              t["No posts available"]
            ) : (
              <div className="spinner-border text-secondary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
          </div>
        )}
      </div>
    </PostsListContainer>
  );
};

export default PostsList;
